/*!
    Site.js
    Created 2020-08-26 Douglas Nordfeldt
    Updated 2024-09-13 Douglas Nordfeldt
*/
'use strict';

var Nefab = window.Nefab || {};


Nefab.IdSrv = $.extend(true, {
    modalLoadingMessage: '<div class="text-center mt-5 mb-5"><h4><i class="fa fa-solid fa-sync fa-spin"></i> Loading...</h4></div>',
    ajaxFailed: function (xhr) {
        console.log('AJAX ERROR!', xhr, this);
        var message = xhr.responseText && xhr.responseText !== '' ? xhr.responseText : xhr.statusText;
        nef.alert(nef.i18n.get('Common.GenericError') + '<br/><br/>' + xhr.status + ' ' + message);
    }
}, Nefab.IdSrv);

//nef.getAntiForgeryToken = function () {
//    var hidden = $('#nef-AntiForgeryToken input:hidden');
//    if (hidden) {
//        return {
//            value: hidden.val(),
//            name: hidden.attr('name')
//        };
//    }
//    return null;
//};

$.ajaxSetup({
    beforeSend: function (xmlHttpRequest) {
        $('#nef-loader-main').show();
        var token = nef.getAntiForgeryToken();
        if (token) {
            xmlHttpRequest.setRequestHeader(token.name.replace('__', ''), token.value);
        }
    },
    complete: function () {
        $('#nef-loader-main').hide();
    }
});

$(document).ready(function () {
    $('.nef-sidemenu-btn').nefSideMenu();
    $('.nef-popup').nefPopup();
});
